var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Two-factor Authentication ")]),
      _c(
        "gg-card-text",
        [
          _vm.isEnabled
            ? _c(
                "v-alert",
                {
                  attrs: {
                    type: "success",
                    dense: ""
                  }
                },
                [_vm._v(" Two-factor Authentication is enabled ")]
              )
            : _vm._e(),
          _c("h4", [_vm._v("What is Two Factor Verification (2FA)?")]),
          _c("p", [
            _vm._v(
              " When enabled with two factor verification, your account will be nearly impossible to hack and is secure against hackers and identity theft. "
            )
          ]),
          _c("h4", [_vm._v("When 2FA is enabled, you will:")]),
          _c("ul", [
            _c("li", [
              _vm._v(
                " Still be able to use your GreenGeeks username and password as usual. "
              )
            ]),
            _c("li", [
              _vm._v(
                " Enter a 2FA code generated by an app on your mobile phone. "
              )
            ])
          ]),
          _c("br"),
          _c("p", [
            _vm._v(
              " The combination of you being the sole person with access to your password and your phone ensures that no one but you can have access to your account. "
            )
          ]),
          _c("p", [
            _vm._v(
              " To begin the process of setting up 2FA for your account, please click the button below. "
            )
          ])
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          !_vm.isEnabled
            ? _c(
                "gg-btn",
                {
                  attrs: {
                    primary: ""
                  },
                  on: {
                    click: function click($event) {
                      return _vm.open2FAModal("enable")
                    }
                  }
                },
                [
                  _vm._v(" Enable Two-factor Security "),
                  _c(
                    "span",
                    {
                      staticClass: "visually-hidden text-lowercase"
                    },
                    [_vm._v("button")]
                  )
                ]
              )
            : _c(
                "gg-btn",
                {
                  attrs: {
                    color: "red",
                    primary: "",
                    dark: ""
                  },
                  on: {
                    click: function click($event) {
                      return _vm.open2FAModal("disable")
                    }
                  }
                },
                [
                  _vm._v(" Disable Two-factor Security "),
                  _c(
                    "span",
                    {
                      staticClass: "visually-hidden text-lowercase"
                    },
                    [_vm._v("button")]
                  )
                ]
              )
        ],
        1
      ),
      _c("two-factor-auth-modal", {
        attrs: {
          show: _vm.showModal
        },
        on: {
          close: _vm.close
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }